import { FieldValues, Path, useFormContext } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "./form";
import { RequiredAsterisk } from "./required-asterisk";
import { MultiSelect } from "../ui/multi-select";

interface FieldMultiSelectProps<TFormValues extends FieldValues> {
  name: Path<TFormValues>;
  label: string;
  hideLabel?: boolean;
  options: { value: string; label: string }[];
  isDisabled?: boolean;
  hasRequiredAsterisk?: boolean;
  title: string;
}
export function FieldMultiSelect<TFormValues extends FieldValues>({
  name,
  label,
  hideLabel = false,
  options,
  isDisabled = false,
  hasRequiredAsterisk = false,
  title,
}: FieldMultiSelectProps<TFormValues>) {
  const form = useFormContext();
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className={`${hideLabel ? "sr-only" : undefined}`}>
            {label}
          </FormLabel>
          {hasRequiredAsterisk && <RequiredAsterisk />}
          <FormControl>
            <MultiSelect
              title={title}
              options={options}
              selectedValues={new Set(field.value)}
              onSelectionChange={(selectedValues) => {
                field.onChange(Array.from(selectedValues));
              }}
              isDisabled={isDisabled}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
